export default {
  name: 'install',
  data: function() {
    return {
      currentComponent: 'entry-component',
      isBlue: true,
      currentQuestionNumber: 1
    }
  },
  watch: {

  },
  computed: {
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    breadCrumbs: function() {
      return this.$store.getters.langFile['overview']
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    },
    overview: function() {
      return this.$store.getters.langFile.overview
    },
    instalText: function() {
      return this.$store.getters.langFile
    }
  },
  methods: {
    goTo: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'test',
        params: {
          id
        }
      })
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/install/install.js